import PropTypes from 'prop-types';
// @mui
import {
  IconButton,
  Switch,
  Typography,
  Stack,
  Tooltip
  } from '@mui/material';

import Iconify from 'src/components/iconify';
import { useAppliedTheme, HEADER_LAYOUT } from 'src/api/app-config';


// ----------------------------------------------------------------------

export default function AppGlobalFilters({ filterCancelledShipments, setCancelledShipmentState, ...other }) {

  const { theme, headerLayout } = useAppliedTheme();
  // On the fixed-background layout, give the control an opaque card surface so
  // the image doesn't show through it while scrolling.
  const onBackground = headerLayout === HEADER_LAYOUT.BACKGROUND && Boolean(theme?.headerImage);

  const handleToggle = () => {
    setCancelledShipmentState((prev) => !prev);
  };

  return (
    <Stack sx={{ display: 'flex', flexDirection: 'column' }}>
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          ...(onBackground && {
            alignSelf: 'flex-start',
            bgcolor: 'background.paper',
            borderRadius: 1.5,
            px: 1.5,
            py: 0.5,
            boxShadow: 3,
          }),
        }}
      >
        <Typography
          variant="body2"
          sx={{
            marginRight: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Considerar cargas canceladas
        </Typography>
        <IconButton
          onClick={handleToggle}
          sx={{
            p: 0,
            '&:hover': {
              boxShadow: 'none',
              backgroundColor: '#ffffff',
            },
          }}
        >
          <Switch color="primary" checked={filterCancelledShipments} />
        </IconButton>
        <Tooltip title={
          <Stack sx={{
            fontSize:"0.83rem"
            }}>
            <p>
              Ao cancelar uma carga, a automação considera o estoque baixado até o momento do cancelamento.
            </p>
            <p>
              Uma carga cancelada na automação, <strong>não necessariamente indica que a entrega foi cancelada</strong>, indica somente que o operador apertou o botão de Cancelar.
            </p>
          </Stack>
          }
          placement="bottom">
          <IconButton>
            <Iconify icon="solar:question-circle-bold" sx={{height:24, width:24}} />
          </IconButton>
        </Tooltip>
      </Stack>
    </Stack>
  );
}

AppGlobalFilters.propTypes = {
  filterCancelledShipments: PropTypes.bool,
  setCancelledShipmentState: PropTypes.func
};
